interface ImagePreviewModalProps {
  imageUrl: string;
  title: string;
  onClose: () => void;
}

export function ImagePreviewModal({ imageUrl, title, onClose }: ImagePreviewModalProps) {
  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div 
        className="relative max-w-5xl max-h-[90vh] bg-white rounded-lg shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="absolute top-0 left-0 right-0 bg-gradient-to-b from-black/70 to-transparent p-4 z-10">
          <div className="flex items-center justify-between">
            <h3 className="text-white font-semibold">{title}</h3>
            <button
              onClick={onClose}
              className="text-white hover:text-gray-300 text-2xl leading-none"
            >
              ✕
            </button>
          </div>
        </div>

        {/* Image */}
        <div className="flex items-center justify-center max-h-[90vh] overflow-auto">
          <img
            src={imageUrl}
            alt={title}
            className="max-w-full max-h-[90vh] object-contain"
          />
        </div>

        {/* Footer hint */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 text-center">
          <p className="text-white text-sm">Click outside to close</p>
        </div>
      </div>
    </div>
  );
}

